import HashScrolling from "../../../../src/scripts/hash-scrolling";

export default class CardGrid {
    static init() {
        document.addEventListener('click', function (event) {
            const cardGridShowAllButton = event.target.closest('.card-grid--show-only-6--show-all');
            if (!cardGridShowAllButton) {
                return;
            }

            const grid = cardGridShowAllButton.closest('.card-grid');
            if (!grid) {
                return;
            }

            const currentHeight = grid.offsetHeight;
            grid.classList.remove('card-grid--show-only-6');
            const finalHeight = grid.offsetHeight;
            grid.style.maxHeight = currentHeight + 'px';


            HashScrolling.scrollToLinkIfIsAbove(grid);

            setTimeout(() => {
                grid.style.maxHeight = finalHeight + 'px';
            }, 100);
            setTimeout(() => {
                event.target.closest('.card-grid--show-only-6--show-all').remove();
            }, 300);
            setTimeout(() => {
                grid.style.maxHeight = 'none';
            }, 2000);
        });

    }
}
